<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="$store.state.analyzers.analyzers"
      class="elevation-1"
    >
      <template v-slot:[`item.action`]="{ item }">
        <router-link :to="{ name: 'Editare analizor', params: { id: item.id } }">
          <v-icon class="mr-2">edit</v-icon>
        </router-link>
        <v-icon @click="deleteItem(item)">delete</v-icon>
      </template>
    </v-data-table>

    <v-layout justify-center>
      <router-link to="/analyzers/create">
        <v-btn color="red" fab small dark fixed bottom justify-center>
          <v-icon>add</v-icon>
        </v-btn>
      </router-link>
    </v-layout>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'ListAnalyzers',
  data() {
    return {
      headers: [
        {
          text: 'ID',
          align: 'center',
          value: 'id',
          sortable: true,
        },
        {
          text: 'Nume',
          align: 'center',
          value: 'name',
          sortable: true,
        },
        {
          text: 'Serie',
          align: 'center',
          value: 'series',
          sortable: true,
        },
        {
          text: 'Data expirare',
          align: 'center',
          value: 'expireAt',
          sortable: true,
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false,
        },
      ],

      pagination: {
        rowsPerPage: 10,
      },
    };
  },
  created() {
    this.getAnalyzers();
  },
  methods: {
    ...mapActions('analyzers', ['getAnalyzers', 'delete']),
    async deleteItem(item) {
      if (window.confirm('Sunteti sigur?')) {
        await this.delete(item.id);
      }
    },
  },
};
</script>
